import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HostComponentDirective } from 'src/app/directives/host-component.directive';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { CheckComponentsService } from 'src/app/services/check-components.service';
import { EventsService } from 'src/app/services/events.service';
import { InitialConfigService } from 'src/app/services/inital-config.service';


@Component({
  selector: 'page-generic-container',
  templateUrl: 'generic-container.html',
  styleUrls: ['generic-container.scss'],
  standalone: false
})
export class GenericContainerPage implements OnInit {
  pageParams: any = {};
  @ViewChild(HostComponentDirective) hostComponent: HostComponentDirective;

  public isEmpty: boolean = false;
  public showGenericSkeleton = true;
  public readonly genericSkeletonBlogPlaceholders = [1];
  public readonly genericSkeletonDocumentPlaceholders = [1, 2];
  private idPage: any;

  constructor(
    public initialConfigProvider: InitialConfigService,
    private checkComponent: CheckComponentsService,
    private analyticsService: AnalyticsService,
    private route: ActivatedRoute,
    private router: Router,
    private events: EventsService
  ) {}

  ngOnInit() {
    this.idPage = this.route.snapshot.paramMap.get('id');

    this.getComponentsPage();
  }

  public refresh($event) {
    this.getComponentsPage($event);
  }

  private async getComponentsPage($event?) {
    this.showGenericSkeleton = true;
    this.initialConfigProvider.getPageComponents(this.idPage).subscribe({
        next: (response) => {
          this.pageParams = response;
          
          // El guard ya se encargó de evaluar el tipo de página
          // Si llegamos aquí, es una página genérica válida
          
          this.isEmpty = this.checkComponent.checkEmptyComponent(this.pageParams.components);
          this.setContentComponents();

          this.events.pages$$.next(response.title);

          this.registerAnalyticsInFirebase(response.title, response.id);

          if ($event && typeof $event.target.complete === 'function') $event.target.complete();
          this.showGenericSkeleton = false;
        },
        error: (error) => {
          console.error(error);
          this.showGenericSkeleton = false;
        }
      });
  }
  private registerAnalyticsInFirebase(namePage, idPage) {
    const paramsToAnalytics = { navigation: 0 };
    this.analyticsService.registerEvent(paramsToAnalytics, namePage, idPage);
  }

  private async setContentComponents() {
    const viewContainerRef = this.hostComponent.viewRef;
    viewContainerRef.clear();
    this.initialConfigProvider.getComponents(this.pageParams.components, viewContainerRef);
  }
}
